window.EMBFabricMap = {

  "gingham-pink":
  "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/2_eac51acb-6a7e-4d0f-9b53-01add5f0b5bf.png?v=1784158391",

  "gingham-red":
  "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/1_1ba4764a-e5dd-4508-a7ca-3d3672c3d13b.png?v=1784158391",

  "gingham-blue":
  "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/3_de41fccd-d232-44d9-8255-37e116c3687c.png?v=1784158391",

  "burlap":
  "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/4_5498f61e-3170-46fb-9ddc-5fe0e4b141f3.png?v=1784158391",

  "leopard":
  "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/5_46d87fd2-ba0e-4467-80c1-03fc9511e568.png?v=1784158391",

  "cheetah":
  "https://cdn.shopify.com/s/files/1/0697/1978/5705/files/6_30e3b412-3f26-40f4-b639-5bd44ad8e49d.png?v=1784158391"

};
async function createFabricPattern(
  ctx,
  fabric
){

  const img =
    new Image();

  img.crossOrigin =
    "anonymous";

  console.log(
"PATTERN REQUEST:",
fabric
);

console.log(
"PATTERN URL:",
window.EMBFabricMap[fabric]
);
    img.src =
    window.EMBFabricMap[fabric];

  await new Promise(
  (resolve,reject)=>{

    img.onload =
      resolve;

    img.onerror =
      reject;

  }
);
console.log(
"FABRIC IMAGE LOADED:",
fabric
);

  return ctx.createPattern(
    img,
    "repeat"
  );

}
window.EMBThumbnail = {

async generateBlob() {

await document.fonts.ready;

const design =
JSON.parse(
localStorage.getItem(
"embroideryDesign"
)
);

const baseImg =
document.querySelector(
"#embroideryBaseImage"
);

if(!baseImg)
throw new Error(
"Base image missing"
);

const canvas =
document.createElement("canvas");

canvas.width =
baseImg.naturalWidth;

canvas.height =
baseImg.naturalHeight;

const ctx =
canvas.getContext("2d");

ctx.drawImage(
baseImg,
0,
0,
canvas.width,
canvas.height
);

console.log(
"DESIGN:",
design
);
/*
IMAGE LAYERS FIRST
*/

for(
  const imageLayer of design.imageLayers
){

  await renderImageLayer(
    ctx,
    imageLayer,
    canvas
  );

}

/*
TEXT LAYERS SECOND
*/

for(
  const layer of design.textLayers
){

  await renderTextLayer(
    ctx,
    layer,
    canvas
  );

}
return await new Promise(resolve =>
canvas.toBlob(
resolve,
"image/png"
)
);

}

};
async function renderTextLayer(
  ctx,
  layer,
  canvas
){

const stage =
document.querySelector(
".embroidery-preview-stage"
);

const stageRect =
stage.getBoundingClientRect();

const scaleX =
canvas.width /
stageRect.width;

const scaleY =
canvas.height /
stageRect.height;

let centerX;
let centerY;


if(layer.curve && layer.curve !== "0"){

  console.log(
  "CURVE DATA",
  layer.centerX,
  layer.centerY,
  layer.radius
);

centerX =
  parseFloat(layer.centerX);

centerY =
  parseFloat(layer.centerY);

if(isNaN(centerX) || isNaN(centerY)){
  console.error(
    "Missing saved curve center",
    layer
  );
  return;
}

centerX *= scaleX;
centerY *= scaleY;

}else{

  centerX =
    parseFloat(layer.left) * scaleX;

  centerY =
    parseFloat(layer.top) * scaleY;

}
console.log(
"THUMBNAIL TEXT POSITION",
{
savedLeft: layer.left,
savedTop: layer.top,
centerX,
centerY,
curve: layer.curve,
text: layer.text
}
);

const size =
parseFloat(layer.fontSize) *
scaleX;

ctx.save();

const fontFamily =
layer.font ||
"Playfair Display";
console.log(
"FONT USED:",
fontFamily
);
ctx.font =
`700 ${size}px ${fontFamily}`;
/*
MONOGRAM
*/

if(layer.monogram){

  ctx.font =
    `700 ${size}px MonogramFont`;

}
/*
PUFF
*/

if(layer.puff === "3d"){

  ctx.shadowColor =
    "rgba(0,0,0,.45)";

  ctx.shadowBlur =
    size * 0.12;

  ctx.shadowOffsetX =
    size * 0.03;

  ctx.shadowOffsetY =
    size * 0.03;

}

ctx.textBaseline = "middle";
ctx.textAlign = "center";

if(
  layer.applique &&
  window.EMBFabricMap[layer.applique]
){

  ctx.fillStyle =
    await createFabricPattern(
      ctx,
      layer.applique
    );

}else{

  ctx.fillStyle =
    layer.color || "#000";

}
console.log(
"THUMBNAIL COLOR:",
layer.color
);
/*
SHADOW
*/

if(layer.shadow === "soft"){

  ctx.shadowColor =
    "rgba(0,0,0,.35)";

  ctx.shadowBlur =
    size * 0.08;

  ctx.shadowOffsetX =
    size * 0.02;

  ctx.shadowOffsetY =
    size * 0.02;

}



/*
CURVED TEXT
*/

if(layer.curve && layer.curve !== "0"){

  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  console.log(
"DRAW CURVE",
{
  text: layer.text,
  centerX,
  centerY,
  radius: layer.radius,
  curveMode: layer.curve
}
);

  drawCurvedText(
  ctx,
  layer,
  layer.text,
  centerX,
  centerY,
  parseInt(layer.curve),
  size,
  (parseFloat(layer.radius) || 120) * scaleX
);

}else{

  if(layer.outline === "classic"){

  ctx.strokeStyle = "#111";

  ctx.lineWidth =
    size * 0.02;

  ctx.strokeText(
    layer.text,
    centerX,
    centerY
  );

}

ctx.fillText(
  layer.text,
  centerX,
  centerY
);

}

/*
RESET SHADOW
*/

ctx.shadowColor =
  "transparent";

ctx.shadowBlur = 0;
ctx.shadowOffsetX = 0;
ctx.shadowOffsetY = 0;

ctx.restore();

}
async function renderImageLayer(
  ctx,
  layer,
  canvas
){

  const stage =
    document.querySelector(
      ".embroidery-preview-stage"
    );

  const stageRect =
    stage.getBoundingClientRect();

  const scaleX =
    canvas.width /
    stageRect.width;

  const scaleY =
    canvas.height /
    stageRect.height;

  const img =
    new Image();

  img.crossOrigin =
    "anonymous";

  img.src =
    layer.src;

  await new Promise(
    resolve =>
      img.onload =
        resolve
  );

  const x =
    parseFloat(layer.left) *
    scaleX;

  const y =
    parseFloat(layer.top) *
    scaleY;

  const width =
    parseFloat(
      layer.width || 150
    ) *
    scaleX;

  const height =
    parseFloat(
      layer.height ||
      layer.width ||
      150
    ) *
    scaleY;

  console.log(
    "DRAWING IMAGE",
    { x, y, width, height }
  );

  ctx.drawImage(
    img,
    x,
    y,
    width,
    height
  );

}
function drawCurvedText(
  ctx,
  layer,
  text,
  centerX,
  centerY,
  curveMode,
  size,
  radius
){

  const letters =
    text.split("");

  

ctx.strokeStyle = "#111";
ctx.lineWidth = size * 0.02;

  let startAngle;
  let stepAngle = 10;

  ctx.save();

  if(curveMode === 1){

    startAngle =
      -((letters.length - 1) * stepAngle) / 2;

    letters.forEach(
      (char,index)=>{

        const angle =
          startAngle +
          (index * stepAngle);

        const rad =
          angle *
          Math.PI /
          180;

        const x =
          centerX +
          Math.sin(rad) *
          radius;

        const y =
          centerY -
          Math.cos(rad) *
          radius;

        ctx.save();

        ctx.translate(
          x,
          y
        );

        ctx.rotate(rad);

        if(
  layer.outline === "classic"
){

  ctx.strokeText(
    char,
    0,
    0
  );

}

ctx.fillText(
  char,
  0,
  0
);

        ctx.restore();

      }
    );

  }

  if(curveMode === 2){

    startAngle =
      -((letters.length - 1) * stepAngle) / 2;

    letters.forEach(
      (char,index)=>{

        const angle =
          startAngle +
          (index * stepAngle);

        const rad =
          angle *
          Math.PI /
          180;

        const x =
          centerX +
          Math.sin(rad) *
          radius;

        const y =
          centerY +
          Math.cos(rad) *
          radius;

        ctx.save();

        ctx.translate(
          x,
          y
        );

        ctx.rotate(-rad);

        if(
  layer.outline === "classic"
){

  ctx.strokeText(
    char,
    0,
    0
  );

}

ctx.fillText(
  char,
  0,
  0
);

        ctx.restore();

      }
    );

  }

  ctx.restore();

}
